import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { ColDef } from 'ag-grid-community';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { CRMModel } from '../../models/CRM';

export interface CRMAgGridTableRef {
  deselectAll: () => void;
}

interface CRMAgGridTableProps {
  orders: CRMModel[];
  columnDefs: ColDef[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  isFetching?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (sorting: { field: string; direction: 'asc' | 'desc' } | null) => void;
  onSelectionChanged?: (rows: CRMModel[]) => void;
}

export const CRMAgGridTable = forwardRef<CRMAgGridTableRef, CRMAgGridTableProps>(
  (
    {
      orders,
      columnDefs,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage,
      isFetching,
      sorting,
      onSortingChange,
      onSelectionChanged,
    },
    ref,
  ) => {
    const agGridRef = useRef<AgGridTableRef>(null);
    const shouldDim = Boolean(isFetching && !isFetchingNextPage);

    useImperativeHandle(ref, () => ({
      deselectAll: () => agGridRef.current?.deselectAll(),
    }));

    return (
      <div className={`w-full transition-opacity duration-300 ${shouldDim ? 'opacity-50 pointer-events-none' : ''}`}>
        <AgGridTable
          ref={agGridRef}
          data={orders}
          columnDefs={columnDefs}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          enableSelection={true}
          onSelectionChanged={onSelectionChanged}
          sorting={sorting ?? null}
          onSortingChange={onSortingChange}
          className="rounded-lg shadow-sm"
          height="calc(100vh - 200px)"
        />
      </div>
    );
  },
);

CRMAgGridTable.displayName = 'CRMAgGridTable';
